import { type PropsWithChildren, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getAuthFailurePopupIsOpen } from '../../model/selectors/auth-failure-popup.selectors';
import { authFailurePopupActions } from '../../model/slices/auth-failure-popup.slice';
import { AuthFailurePopup } from '../auth-failure-popup/auth-failure-popup';

interface AuthFailurePopupProviderProps extends PropsWithChildren {}

export function AuthFailurePopupProvider(props: AuthFailurePopupProviderProps) {
    const { children } = props;

    const dispatch = useDispatch();
    const isOpen = useSelector(getAuthFailurePopupIsOpen);

    const handleClose = useCallback(() => {
        dispatch(authFailurePopupActions.hidePopup());
    }, [dispatch]);

    // Debug: Ctrl+Shift+A to trigger modal for testing
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.ctrlKey && event.shiftKey && event.key === 'A') {
                dispatch(authFailurePopupActions.showPopup());
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [dispatch]);

    return (
        <>
            {children}
            <AuthFailurePopup
                isOpen={isOpen}
                onClose={handleClose}
            />
        </>
    );
}
